// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"SeguimientoSolicitudes__tabsContainer__3TL9s"};